// extracted by mini-css-extract-plugin
module.exports = {"prognosisWarningBox":"VehicleWithdrawalTable_prognosisWarningBox_3X7BZ"};